import { render, staticRenderFns } from "./BulkHandlingFeeModal.vue?vue&type=template&id=21976b85&scoped=true&"
import script from "./BulkHandlingFeeModal.vue?vue&type=script&lang=js&"
export * from "./BulkHandlingFeeModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkHandlingFeeModal.vue?vue&type=style&index=0&id=21976b85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21976b85",
  null
  
)

export default component.exports